import React, { memo } from 'react';
import Link from 'components/Link';
import s from './StatusCardTitle.scss';
import InfoMsg, { positions } from '../InfoMsg/InfoMsg';

const StatusCardTitle = ({
  hideLink,
  name,
  path,
  infoMsg,
  activeSeats,
  smallSize,
  ws_ls,
  isExitPoll = true,
  totalSeats,
  tableView = false,
  majority,
  ws,
  normalView = true,
}) => (
  <div className={`${s.stateName} ${smallSize ? s.smallSize : ''}`}>
    {hideLink ? (
      <a
        onClick={e => {
          e.preventDefault();
        }}
        href={path}
        rel="nofollow noreferrer"
        // eslint-disable-next-line react/no-unknown-property
        frmappuse="1"
        target="_blank"
      >
        {name}
      </a>
    ) : (
      <Link
        onClick={e => {
          // eslint-disable-next-line no-unused-expressions
          hideLink ? e.preventDefault() : null;
        }}
        href={path}
        data-newga={`click-ElectionWidget#${path}`}
        target="_blank"
        ga4Data={[
          {
            event: 'user_click',
            type: 'exitpoll_widget',
            category: name,
            label: name,
          },
        ]}
      >
        {name}
      </Link>
    )}
    {!isExitPoll &&
      normalView &&
      activeSeats && (
        <div className={s.totalSeats}>
          <span>
            {ws === activeSeats ? 'Results' : 'L+W'}: {!isExitPoll && ws_ls}/{
              totalSeats
            }
          </span>
          {infoMsg && <InfoMsg msg={infoMsg} position={positions.RIGHT} />}
        </div>
      )}
    {isExitPoll &&
      normalView && (
        <div className={s.totalSeats}>
          <span>{totalSeats}</span>
          {infoMsg && <InfoMsg msg={infoMsg} position={positions.RIGHT} />}
        </div>
      )}
    {tableView &&
      isExitPoll &&
      totalSeats &&
      majority && (
        <div className={s.totalSeats}>
          {totalSeats && (
            <span>
              Seats: <strong>{totalSeats}</strong>
            </span>
          )}
          <span className={s.seprator}>|</span>
          {majority && (
            <span>
              Majority: <strong>{majority}</strong>
            </span>
          )}
          {infoMsg && <InfoMsg msg={infoMsg} position={positions.RIGHT} />}
        </div>
      )}
  </div>
);

export default memo(StatusCardTitle);
